import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_setting_card = _resolveComponent("setting-card")!

  return (_ctx.config)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_setting_card, _mergeProps(_ctx.binds, {
          onUpdateProfile: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateProfile())),
          hideMoreVert: true,
          hidePrevious: true,
          active: _ctx.config.stock,
          "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.config.stock) = $event))
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "d-flex justify-center",
              style: {"min-width":"650px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "8",
                  class: "pb-2 text-h6 pl-3"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" Option pour la gestion des stocks ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "8" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "rounded-xl border-thin px-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "9",
                          class: "d-flex align-center"
                        }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createTextVNode(" Uniquement l'inventaire ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "3",
                          class: "d-flex justify-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateConfiguration())),
                              modelValue: _ctx.config.stockConfig.onlyInventory,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.stockConfig.onlyInventory) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16, ["active"])
      ]))
    : _createCommentVNode("", true)
}